<template>
  <div class="table_container">
    <div class="table-btn" style="margin: 0 0 12px 0">
      <el-button
        v-if="$route.query.operateType !== '查看'"
        type="primary"
        size="small"
        @click="handleAddOrEdit('新增渠道信息')"
        >新增</el-button
      >
    </div>
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
    >
      <!-- 序号 -->
      <el-table-column label="序号" width="50px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- 网点名称 -->
      <el-table-column
        prop="outletsName"
        label="网点名称"
        min-width="90px"
        align="center"
      />
      <!-- 店面类别 -->
      <el-table-column
        prop="storefrontType"
        label="店面类别"
        min-width="90px"
        align="center"
      />
      <!-- 店面选址说明(所处位置，周边竞品等) -->
      <el-table-column
        prop="storefrontAddress"
        label="店面选址说明 (所处位置，周边竞品等)"
        min-width="180px"
        align="center"
      />
      <!-- 团队构成 -->
      <el-table-column
        prop="teamComposition"
        label="团队构成"
        min-width="90px"
        align="center"
      />
      <!-- 团队能力说明(投资人状态及市场人员能力、销售人员能力说明) -->
      <el-table-column
        prop="teamCapacityRemark"
        label="团队能力说明(投资人状态及市场人员能力、销售人员能力说明)"
        min-width="180px"
        align="center"
      />
      <!-- 投资人投资汇报满意度说明(专营店：利润；综合店：收入、利润占比) -->
      <el-table-column
        prop="investorsSatisfiedRemark"
        label="投资人投资汇报满意度说明(专营店：利润；综合店：收入、利润占比)"
        min-width="180px"
        align="center"
      />
      <!-- 售后服务能力 -->
      <el-table-column
        prop="afterSaleServiceAbility"
        label="售后服务能力"
        min-width="90px"
        align="center"
      />
      <!-- 与竞品的销量对标(同一区域的竞品门店销量对比；品牌、车型、销量) -->
      <el-table-column
        prop="competitionSaleBenchmarking"
        label="与竞品的销量对标(同一区域的竞品门店销量对比；品牌、车型、销量)"
        min-width="180px"
        align="center"
      />
      <!-- 备注 -->
      <el-table-column
        prop="remark"
        label="备注"
        min-width="90px"
        align="center"
      />
      <!-- 操作 -->
      <el-table-column label="操作" align="center" width="90px" fixed="right">
        <template slot-scope="scope">
          <!-- 编辑 -->
          <el-button
            v-if="$route.query.operateType !== '查看'"
            size="mini"
            type="text"
            @click="handleAddOrEdit('编辑渠道信息', scope.row)"
            >编辑</el-button
          >
          <!-- 查看 -->
          <el-button
            size="mini"
            type="text"
            @click="handleAddOrEdit('查看渠道信息', scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <form-dialog ref="formDialog" @success="getChannelInfo" />
  </div>
</template>

<script>
import FormDialog from "./formDialog.vue";
import { getChannelInfoApi } from "@/api/saleTaskCollection";

export default {
  components: {
    FormDialog
  },
  data() {
    return {
      tableData: []
    };
  },
  created() {
    this.getChannelInfo();
  },
  methods: {
    // 获取渠道信息
    async getChannelInfo() {
      try {
        if (this.$route.query.areaName && this.$route.query.countryName) {
          const res = await getChannelInfoApi({
            areaName: this.$route.query.areaName,
            countryName: this.$route.query.countryName
          });
          if (res.status == 0) {
            this.tableData = res.data || {};
          } else {
            this.$DonMessage.error(res.message);
          }
        }
      } catch (error) {}
    },
    // 添加 | 编辑
    handleAddOrEdit(title, data) {
      if (!this.$route.query.baseInfoId) {
        this.$DonMessage.warning("请先保存基础信息");
        return;
      }
      this.$refs.formDialog.init(title, data);
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
}
</style>
